<h4 mat-dialog-title class="px-5" data-cy="task-success">
    <i class="fa-regular fa-square-check pe-2"></i>{{ 'task_success.title' | translate }}
</h4>
<div mat-dialog-content class="p-5 pt-3">
    <p>{{ 'task_success.desc' | translate }}</p>
    <task-actions [task]="currentTask"
                  [context]="'task-success-dialog'"
                  (onAction)="action($event)"></task-actions>
</div>